<script lang="ts">
export interface ListboxContextProviderProps {
  dataTestid?: string;
  isOpen: boolean;
}
</script>
<script lang="ts" setup>
import { readonly, toRef } from 'vue';

import { provideListboxContext } from './context';

const props = defineProps<ListboxContextProviderProps>();

provideListboxContext({
  dataTestid: readonly(toRef(props, 'dataTestid')),
  isOpen: readonly(toRef(props, 'isOpen')),
});
</script>

<template>
  <slot />
</template>
